// Import CSS
import '../css/index.scss'
import 'ckeditor5/dist/ckeditor5.css';
import 'alpinejs'

// CKEditor 5
import {
    ClassicEditor,
    Essentials,
    Paragraph,
    Heading,
    Bold,
    Italic,
    Underline,
    Link,
    LinkUI,
    List,
    ListProperties,
    Alignment,
    Plugin,
    ButtonView
} from 'ckeditor5';
/*  Import Vue
import Vue from 'vue';
import App from './app.vue';

new Vue({
  el: '#app',
  render: h => h(App)
});
*/
// Commenting out search js for now. Apparently an error gets thrown if running locally.
import './search'
import './common'
 
 
function initDescriptionEditor() {
    const textarea = document.getElementById('description');

    if (!textarea || textarea.dataset.ckeditorInitialized) {
        return;
    }

    textarea.dataset.ckeditorInitialized = 'true';

    ClassicEditor.create(textarea, {
    licenseKey: 'GPL',
    plugins: [
    Essentials,
    Paragraph,
    Heading,          // Required for Paragraph / Heading dropdown
    Bold,
    Italic,
    Underline,
    Link,
    List,
    ListProperties,   // Required for list-style options
    Alignment
],

toolbar: [
    'heading', '|',
    'bold', 'italic', 'underline', 'link', '|',
    'alignment', '|',
    'bulletedList', 'numberedList'
],
 link: {
        decorators: {
            openInNewTab: {
                mode: 'manual',
                label: 'Open in new tab?',
                attributes: {
                    target: '_blank',
                    rel: 'noopener noreferrer'
                }
            }
        }
    },
    heading: {
    options: [
        { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
        { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
        { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
        { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
        { model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4' },
        { model: 'heading5', view: 'h5', title: 'Heading 5', class: 'ck-heading_heading5' },
        { model: 'heading6', view: 'h6', title: 'Heading 6', class: 'ck-heading_heading6' }
    ]
},
    alignment: {
        options: ['left', 'center', 'right', 'justify']
    },
    list: {
        properties: {
            styles: true,
            startIndex: true,
            reversed: true
        }
    }
})
        .then(editor => {
            window.descriptionEditor = editor;

            const syncDescription = () => {
                const html = editor.getData();
                textarea.value = html;

                // Alpine.js v2 compatibility
                const root = textarea.closest('[x-data]');

                if (root && root.__x && root.__x.$data) {
                    root.__x.$data.description = html;
                }
            };

            editor.model.document.on('change:data', syncDescription);

            const form = textarea.closest('form');

            if (form) {
                form.addEventListener('submit', syncDescription, true);
            }

            syncDescription();
        })
        .catch(error => {
            textarea.dataset.ckeditorInitialized = '';
            console.error('CKEditor initialization failed:', error);
        });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDescriptionEditor);
} else {
    initDescriptionEditor();
} 